import { Component, EventEmitter, Input, OnInit, Output, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { Store } from '@ngrx/store';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { ApplicantForm } from '../../forms/applicant.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../openapi';
import { UserDetails } from '../../../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../../../store/selectors/user-details.selectors';
import { SessionService } from '../../../../../../../services/ssession.service';

@Component({
  selector: 'app-natural-person-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective
  ],
  templateUrl: './natural-person-form.component.html'
})
export class NaturalPersonFormComponent implements OnInit {

  private entityType = '14115421-88f2-431a-8310-203c68180b33';

  @Input()
  public autoFillButtons = true;

  @Input()
  public form: ApplicantForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  constructor(private store$: Store) {
  }

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.entityType });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.entityType });
  }

  public ngOnInit(): void {
    this.form?.applicantType.setValue(this.entityType);

    this.form?.name.disable();
    this.form?.nip?.disable();

    this.form?.firstName.enable();
    this.form?.lastName.enable();
  }
}
